<svelte:head>
	<!--TODO include css differently -->
	<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/swagger-ui/3.51.1/swagger-ui.css" />
</svelte:head>

<script>
	import SwaggerUI from "swagger-ui";
	import { apiCatalogue} from '../stores/stores';

	export let id;
	let docEl;

	$: doc = $apiCatalogue.length ? $apiCatalogue.filter(d => d.id === id) : '';

	$: if (doc && docEl) {
		SwaggerUI({
			url: doc.length ? doc[0].url : '',
			domNode: docEl,
		});
	}

</script>

<div bind:this={docEl} />
